<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.user_data") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #f7941e">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <!-- Start:: Account Data Section -->
          <div class="col-12">
            <h3 class="section_title mb-4">
              <i class="fal fa-user mr-2"></i>
              {{ $t("PLACEHOLDERS.account_data") }}
            </h3>
          </div>

          <div class="cols-lg-12">
            <img :src="data.profile_image" alt="user" class="profile-image" />
          </div>
          <!-- Full Name -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.full_name')"
            v-model="data.full_name"
            disabled
          />

          <!-- ID Number -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.identity_number')"
            v-model="data.id_number"
            disabled
          />

          <!-- Mobile Number -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model="data.mobile"
            disabled
          />

          <!-- Email -->
          <base-input
            col="6"
            type="email"
            :placeholder="$t('PLACEHOLDERS.sender_email')"
            v-model="data.email"
            disabled
          />

          <!-- City -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.city')"
            v-model="data.city"
            disabled
          />

          <!-- Gender -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.gender')"
            v-model="data.gender"
            disabled
          />

          <!-- Birth Date -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.birth_date')"
            v-model="data.birth_date"
            disabled
          />

          <!-- Start:: Subscription Data Section -->
          <div class="col-12 mt-4">
            <h3 class="section_title mb-4">
              <i class="fal fa-crown mr-2"></i>
              {{ $t("PLACEHOLDERS.subscription_data") }}
            </h3>
          </div>

          <!-- Subscription Status -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.subscription_status')"
            v-model="data.subscription_status_text"
            disabled
          />

          <!-- Subscription Start Date -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.subscription_start_date')"
            v-model="data.subscription_start_date"
            disabled
          />

          <!-- Subscription End Date -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.subscription_end_date')"
            v-model="data.subscription_end_date"
            disabled
          />

          <!-- Remaining Days -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.remaining_days')"
            v-model="data.remaining_days"
            disabled
          />

          <!-- Start:: App Usage Section -->
          <div class="col-12 mt-4">
            <h3 class="section_title mb-4">
              <i class="fal fa-chart-bar mr-2"></i>
              {{ $t("PLACEHOLDERS.app_usage_data") }}
            </h3>
          </div>

          <!-- Attended Ads Count -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.attended_ads_count')"
            v-model="data.attended_ads_count"
            disabled
          />

          <!-- Attendance Confirmation Count -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.attendance_confirmation_count')"
            v-model="data.attendance_confirmation_count"
            disabled
          />

          <!-- QR Usage Count -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.qr_usage_count')"
            v-model="data.qr_usage_count"
            disabled
          />
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "SingleClient",

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      // Start:: Loading Data
      isWaitingRequest: false,
      // End:: Loading Data

      // Start:: Data
      data: {
        // Account Data
        full_name: null,
        id_number: null,
        mobile: null,
        email: null,
        city: null,
        gender: null,
        birth_date: null,
        profile_image: null,
        // Subscription Data
        subscription_status: null,
        subscription_status_text: null,
        subscription_start_date: null,
        subscription_end_date: null,
        remaining_days: null,

        // App Usage Data
        attended_ads_count: null,
        attendance_confirmation_count: null,
        qr_usage_count: null,
      },
      // End:: Data
    };
  },

  methods: {
    // Start:: Get Data To Show
    async getDataToShow() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `users/${this.id}`,
        });

        const userData = res.data.data.User;

        // Account Data
        this.data.full_name = userData.name;
        this.data.profile_image = userData.image;

        this.data.id_number = userData.nationalId || "-";
        this.data.mobile = userData.country_code
          ? `${userData.country_code}${userData.mobile}`
          : userData.mobile;
        this.data.email = userData.email;
        this.data.city = userData.city_name || "-";
        this.data.gender = this.getGenderText(userData.gender);
        this.data.birth_date = userData.date_of_birth || "-";

        // Subscription Data
        this.data.subscription_status = userData.subscription;
        this.data.subscription_status_text = this.getSubscriptionStatusText(
          userData.subscription
        );
        this.data.subscription_start_date =
          userData.subscription_data?.start_date ;
        this.data.subscription_end_date =
          userData.subscription_data?.end_date || "-";
        this.data.remaining_days =
          userData.free_trail_days ||
          this.calculateRemainingDays(userData.subscription_data?.end_date);

        this.data.attended_ads_count = userData.attended_ads_count || 0;
        this.data.attendance_confirmation_count =
          userData.attendance_confirmation_count || 0;
        this.data.qr_usage_count = userData.qr_usage_count || 0;
      } catch (error) {
        this.$message.error(
          error.response?.data?.message ||
            this.$t("MESSAGES.error_fetching_data")
        );
      }
    },
    // End:: Get Data To Show

    // Start:: Get Gender Text
    getGenderText(gender) {
      if (gender === "male") {
        return this.$t("PLACEHOLDERS.male");
      } else if (gender === "female") {
        return this.$t("PLACEHOLDERS.female");
      } else {
        return this.$t("TABLES.noData");
      }
    },
    // End:: Get Gender Text

    // Start:: Get Subscription Status Text
    getSubscriptionStatusText(status) {
      if (status === "subscribed") {
        return this.$t("PLACEHOLDERS.subscribed");
      } else if (status === "trial") {
        return this.$t("PLACEHOLDERS.trial");
      } else {
        return this.$t("PLACEHOLDERS.not_subscribed");
      }
    },
    // End:: Get Subscription Status Text

    // Start:: Calculate Remaining Days
    calculateRemainingDays(endDate) {
      if (!endDate) return 0;
      const today = new Date();
      const end = new Date(endDate);
      const diffTime = end - today;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays > 0 ? diffDays : 0;
    },
    // End:: Calculate Remaining Days
  },

  created() {
    // Start:: Fire Methods
    this.getDataToShow();
    // End:: Fire Methods
  },
};
</script>
<style lang="scss" scoped>
.section_title {
  color: #28877b;
  font-size: 1.4rem;
  font-weight: 600;
  border-bottom: 2px solid #28877b;
  padding-bottom: 12px;

  i {
    color: #28877b;
  }
}

@media (max-width: 767px) {
  .section_title {
    font-size: 1.2rem;
  }
}
.profile-image {
  width: 200px;
  margin: auto;
  border-radius: 7px;
  display: block;
}
</style>
